import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { createApiInstance } from '../../../config/api';
import { getCategory, getMentorView } from '../mentorProfile';
import ProfileView from '../ProfileView';
import './App.css';

class OtherProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      similar: [],
      loading: true,
      error: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.fetchProfile(match.params.id);
    } else {
      this.setState({ loading: false });
    }
  }

  fetchProfile = async (userId) => {
    try {
      const api = createApiInstance();
      const res = await api.get(`/profile/${userId}`);
      const user = res.data;
      this.setState({ user, loading: false });
      if (user?.role === 'Mentor' || (user?.history?.[0] && !user?.history?.[0].standard)) {
        this.fetchSimilar(user);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      this.setState({ loading: false, error: true });
    }
  };

  fetchSimilar = async (user) => {
    try {
      const api = createApiInstance();
      const res = await api.get('/allmentors');
      const category = getCategory(user);
      const similar = (res.data || [])
        .filter(m => m._id !== user._id && getCategory(m) === category)
        .slice(0, 3)
        .map(getMentorView);
      this.setState({ similar });
    } catch (error) {
      console.error('Error fetching similar mentors:', error);
    }
  };

  render() {
    const { user, similar, loading, error } = this.state;

    if (loading) {
      return (
        <div className="mm">
          <ReactLoading style={{ color: "black", margin: "auto", height: "15%", width: "15%" }} type={"spinningBubbles"} />
        </div>
      );
    }

    if (error || !user) {
      return (
        <div className="mm">
          <div className="mm-loading">Profile not found or could not be loaded.</div>
        </div>
      );
    }

    return <ProfileView user={user} isOwnProfile={false} similar={similar} />;
  }
}

export default withRouter(OtherProfile);
